import { supabase } from "./supabaseClient";

// Reads subdomain from the browser address bar.
// coop.vibelms.com.au  -> "coop"
// vibelms.com.au       -> "coop" (default for now)
export function getTenantSlugFromHost() {
  const host = window.location.hostname;

  // Local development fallback
  if (host === "localhost" || host.startsWith("localhost")) return "coop";

  const parts = host.split(".");

  // subdomain.domain.tld -> subdomain
  if (parts.length >= 3) return parts[0];

  // no subdomain -> default tenant
  return "coop";
}

// Loads the tenant row from Supabase based on the slug
export async function loadTenant() {
  const slug = getTenantSlugFromHost();

  const { data, error } = await supabase
    .from("tenants")
    .select("*")
    .eq("slug", slug)
    .single();

  if (error) throw error;

  return data; // { id, slug, primary_colour, secondary_colour, ... }
}

